import { Component, computed, input, output } from '@angular/core'
import { RouterLink } from '@angular/router'
import { Uuid } from '@ftr/contracts/type/shared'
import {
  AnchorComponent,
  EmptyStateComponent,
  IconButtonComponent,
  selectWith,
  TypedContextDirective,
} from '@ftr/foundation'
import { AppPaths, RequestPaths } from '@ftr/routing-paths'
import { CartState } from '../../../store'
import { RequestTypeUrlValue } from '../../../types'
import { RequestCartGroupComponent } from '../cart-group'
import { CartTimesDisplayComponent } from '../cart-times-display'

@Component({
  selector: 'ftr-request-cart-side-panel',
  templateUrl: './request-cart-side-panel.component.html',
  styleUrl: './request-cart-side-panel.component.css',
  imports: [
    AnchorComponent,
    CartTimesDisplayComponent,
    EmptyStateComponent,
    IconButtonComponent,
    RequestCartGroupComponent,
    RouterLink,
    TypedContextDirective,
  ],
})
export class RequestCartSidePanelComponent {
  readonly courtSystemId = input.required<Uuid>()
  readonly requestType = input.required<RequestTypeUrlValue>()

  readonly closePanel = output()

  protected readonly cartGroups = selectWith(() => CartState.groupedCartItems)
  protected readonly cartPath = computed(() => [
    '/',
    AppPaths.Request,
    this.requestType(),
    RequestPaths.CourtSystem,
    this.courtSystemId(),
    RequestPaths.Cart,
  ])
  protected readonly checkoutPath = computed(() => [
    '/',
    AppPaths.Request,
    this.requestType(),
    RequestPaths.CourtSystem,
    this.courtSystemId(),
    RequestPaths.Checkout,
  ])
}
